import axios from "axios";

export default {
    get(role, type) {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/menu",
            params: {
                role: role,
                type: type,
            },
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getSetting(role, type) {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/settingMenu",
            params: {
                role: role,
                type: type,
            },
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
};
